// src/config/appConfig.js
const API_CONFIG = {
  development: {
    BASE_URL: 'http://localhost:8000/api',  // Aggiornato per Laravel
    UPLOAD_URL: 'http://localhost:8000',   // URL per l'upload delle immagini
    STRIPE_KEY: 'pk_test_51QErCSGWFmxQmtBHU5ow8a3eSWNzGx7503b2cdbgCUCqugrovQbAHPl0BFSZiv60sQJYaaNvxhYsNsY4jOCzy4lK00sZS9gQ7b'
  },
  production: {
    BASE_URL: 'https://back-therapy.smartdevagency.cloud/api',  // Aggiorna con il tuo dominio di produzione
    UPLOAD_URL: 'https://back-therapy.smartdevagency.cloud/',   // URL per l'upload delle immagini in produzione
    STRIPE_KEY: 'pk_test_51QErCSGWFmxQmtBHU5ow8a3eSWNzGx7503b2cdbgCUCqugrovQbAHPl0BFSZiv60sQJYaaNvxhYsNsY4jOCzy4lK00sZS9gQ7b'
  },
 };
 
 const ENVIRONMENT = process.env.NODE_ENV || 'development';
 
 const API_PREFIX = API_CONFIG[ENVIRONMENT].BASE_URL;
 const UPLOAD_PREFIX = API_CONFIG[ENVIRONMENT].UPLOAD_URL;
 const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY || API_CONFIG[ENVIRONMENT].STRIPE_KEY;
 
 export { API_PREFIX, UPLOAD_PREFIX, STRIPE_PUBLIC_KEY };